define(function(require) {
	const ViewManager = require('civicsUtils/view_manager');

	'use strict';

	const oauth = require('oauth4webapi');

	const OAuthHelper = {
		setSocialLoginRedirectURLInSessionStorage:(url)=>{
		if(url && url.trim() != ''){
				App.sessionStorage.set('CIVICS_REDIRECT', 'SOCIALLOGINREDIRECT', url);
			} else {
				App.sessionStorage.remove('CIVICS_REDIRECT', 'SOCIALLOGINREDIRECT');
			}
		},
		getSocialUserInfo: function () {
			// get stored social info from session storage
			var socialInfo = App.sessionStorage.get('CIVICS', 'SOCIAL_INFO');
			if(socialInfo) {
				var providerId = socialInfo.provider;
				var provider = this.getProvider(providerId);
				
				var info = {};
				info.providerDisplayName = socialInfo.providerDisplayName;
				info.socialLoginEmail = socialInfo.email;
				info.socialLoginUserId = socialInfo.uniqueIdentifier;
				info.socialLoginFirstName = socialInfo.firstName;
				info.socialLoginLastName = socialInfo.lastName;
				info.socialLoginAccessToken = socialInfo.accessToken;
				info.providerName = provider.providerName;
				info.providerId = provider.providerId;
				info.registrationToken = socialInfo.registrationToken;

				var icon = this.createIconElement(provider);
				info.providerIcon = icon;
			}

			return info;
		},
		createIconElement: function(provider) {
			// create an <svg> element from the value in config
			var iconStr = provider.icon;
			if(iconStr == null) {
				return null;
			}


			const parser = new DOMParser();
			const svgDoc = parser.parseFromString(iconStr, "image/svg+xml");
			const svgElement = svgDoc.documentElement;
			svgElement.setAttribute('class','icon');
			svgElement.setAttribute('aria-label', provider.providerName);

			var span = $("<span></span>");
			span.append(svgElement);

			return span[0].outerHTML;
		},
		getProvider: function(providerId) {

			const providers = ViewManager.globalConfig().get('login').get('socialLogins').toJSON();
			for (let i = 0; i < providers.length; i++) {
				if (providers[i].providerId === providerId) {
					return providers[i];
				}
			}
			return null;
		},
		generateRandomString: function(length) {
			return oauth.generateRandomCodeVerifier();
		},

		storeOAuthState: function(providerId, state, codeVerifier, codeChallenge) {
			sessionStorage.setItem('oauth_state', JSON.stringify({
				state: state,
				codeVerifier: codeVerifier,
				codeChallenge: codeChallenge,
				timestamp: Date.now(),
				provider: providerId
			}));
		},

		retrieveOAuthState: function() {
			// retrieve stored oauth state from session storage
			const stored = sessionStorage.getItem('oauth_state');
			if (stored) {
				sessionStorage.removeItem('oauth_state');
				return JSON.parse(stored);
			}
			return null;
		},

		buildAuthorizationUrl: function(provider, redirectUri) {
			// create authorization url for the provider
			const codeVerifier = oauth.generateRandomCodeVerifier();
			const state = oauth.generateRandomState();

			// generate code and code verifier
			return oauth.calculatePKCECodeChallenge(codeVerifier).then(function(codeChallenge) {
				this.storeOAuthState(provider.providerId, state, codeVerifier, codeChallenge);

				const authUrl = new URL(provider.authorizationEndpoint);
				authUrl.searchParams.set('client_id', provider.clientId);
				authUrl.searchParams.set('redirect_uri', redirectUri);
				authUrl.searchParams.set('response_type', 'code');
				authUrl.searchParams.set('scope', provider.scope);
				authUrl.searchParams.set('state', state);
				authUrl.searchParams.set('code_challenge', codeChallenge);
				authUrl.searchParams.set('code_challenge_method', 'S256');
				
				if (provider.providerId === 'apple') {
					authUrl.searchParams.set('response_mode', 'form_post');
				}

				return authUrl.toString();
			}.bind(this));
		},

		handleCallback: function(serverParams, onSuccess, onError) {
		let code = serverParams?.oauthCode || '';
		let state = serverParams?.oauthState || '';
		let error = serverParams?.oauthError || '';
		let user = serverParams?.user || null;

			if (error) {
				onError('OAuth error: ' + error);
				ViewManager.loading(false);
				return;
			}

			if (!code || !state) {
				ViewManager.loading(false);
				return;
			}

			let storedState = null;
			
			const stored = this.retrieveOAuthState();
			var provider = this.getProvider(stored.provider);

			if(stored && stored.state === state) {
				storedState = stored;
			} 
		
			if (!provider || !storedState) {
				ViewManager.loading(false);
				onError('OAuth error: Invalid state parameter');
				return;
			}
			
			onSuccess(provider.providerId, {
				code: code,
				codeVerifier: storedState.codeVerifier,
				state: state,
				user: user
			});

		},

		cleanupUrl: function() {
			const url = new URL(window.location.href);
			url.searchParams.delete('code');
			url.searchParams.delete('state');
			url.searchParams.delete('error');
			window.history.replaceState({}, document.title, url.toString());
		}
	};

	return OAuthHelper;
});
